module.exports = __webpack_public_path__ + "img/100.afd89d05.jpg";